export const recursionDetectionMiddleware = () => (next) => async (args) => next(args);
